import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { SmPlainTextComponent } from 'src/app/modules/shared/popover/sm-plain-text/sm-plain-text.component';
import { VisaStatusNoteInputComponent } from 'src/app/modules/visa/add/document-collection/visa-status-note-input/visa-status-note-input.component';

@Component({
  selector: 'app-status-progress-bar-input',
  templateUrl: './status-progress-bar-input.component.html',
  styleUrls: ['./status-progress-bar-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StatusProgressBarInputComponent),
      multi: true,
    },
  ],
})
export class StatusProgressBarInputComponent implements OnInit, ControlValueAccessor {

  // Use LOV here
  @Input() steps: any[] = [
    { name: 'Document Collection', key: 'Document Collection', note: '', checked: false },
    { name: 'Document Verification', key: 'Document Verification', note: '', checked: false },
    { name: 'Application Completed', key: 'Application Completed', note: '', checked: false },
    { name: 'Application Submitted', key: 'Application Submitted', note: '', checked: false },
    { name: 'Visa Appointment', key: 'Visa Appointment', note: '', checked: false },
    { name: 'Visa Processing', key: 'Visa Processing', note: '', checked: false },
    { name: 'Visa Decision', key: 'Visa Decision', note: '', checked: false },
    { name: 'Visa Collected', key: 'Visa Collected', note: '', checked: false },
  ];

  currentStep!:number;
  @Input() isDisabled: boolean = false;

  // ControlValueAccessor Functions
  private onChange: (value: any[]) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private _popoverController: PopoverController) { }

  ngOnInit() { }

  get progressPercentage() {
    if(this.currentStep !== undefined && this.currentStep !== null){
      return ((this.currentStep + 1) / this.steps.length) * 100;
    }else{
      return 0;
    }
    
  }

  selectStep(index: number) {
    this.currentStep = index;

    // Mark current and all previous steps as checked
    this.steps.forEach((step, i) => {
      step.checked = i <= index;
    });

    this.notifyParent(); // Notify the parent with the updated data
  }

  async openInfomationPopover(event: any, step: any) {
    const popover = await this._popoverController.create({
      component: SmPlainTextComponent,
      event: event,
      componentProps: {
        data: step.note || 'No notes available',
      },
    });
    return await popover.present();
  }

  async openStatusNotesInput(event: any, step: any) {
    const popover = await this._popoverController.create({
      component: VisaStatusNoteInputComponent,
      event: event,
      componentProps: {
        data: step.note || '',
        emitDataChanged: (data: any) => {
          step.note = data; // Update the note for the step
          this.notifyParent(); // Notify the parent with the updated data
        }
      },
    });

    return await popover.present();
  }

  private notifyParent() {
    this.onChange(this.steps); // Send the updated steps array to the parent
    this.onTouched(); // Mark the control as touched
  }

  // ControlValueAccessor Methods
  writeValue(value: any[]): void {
    if (value) {
      this.steps = value;

      // Update the currentStep based on the highest checked step
      const lastCheckedIndex = this.steps.findIndex((step) => !step.checked) - 1;
      this.currentStep = lastCheckedIndex >= 0 ? lastCheckedIndex : this.steps.length - 1;

      // Ensure all previous steps are marked as checked
      this.steps.forEach((step, i) => {
        step.checked = i <= this.currentStep;
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // this.isDisabled = isDisabled;
  }
}
